import { render, staticRenderFns } from "./Beranda.vue?vue&type=template&id=6fd48d97&"
import script from "./Beranda.vue?vue&type=script&lang=js&"
export * from "./Beranda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports